import type { FaireProductEntity } from "../../entity_types/product";

export const p_n9vgmnxhvj: FaireProductEntity = {
  token: "p_n9vgmnxhvj",
  type: "product",
  name: "PT17846 - Blake Half Zip Top and Shorts Set",
  brandToken: "b_2yfoe3nc8k",
  brandName: "Papermoon",
  imageUrl:
    "https://cdn.faire.com/fastly/fae1851350a0889907f6a2b4f681aa51b66d0372420d360ad5d907c1d7ca4b49.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4bb364919c27b41bba15d81f27090669017e2b41d57675658cf8ca09dc3ff98b.jpeg",
    "https://cdn.faire.com/fastly/26de2f1b86282fd4bdbbee2e2dec7d068d86c1fdd2256f1e03ddd4be5297199f.jpeg",
    "https://cdn.faire.com/fastly/e3ba7e44924f912d47ffa355a6a37093eaab660d64cbe4fe84b69201cc3a66fe.jpeg",
    "https://cdn.faire.com/fastly/08e3f23add788d1c3c727820c678b4c36f61774baba816a19700b2199148c557.jpeg",
    "https://cdn.faire.com/fastly/34f00703b7da04b4aa971e5105e9fb844eaf034607a8398b9a6175eaefaaa4c8.jpeg",
    "https://cdn.faire.com/fastly/c9ed761216177cf6bf6477835c8212334594e3df49eda0af4be460d1e64e959f.jpeg",
    "https://cdn.faire.com/fastly/94e709aa82797d446d0f640b5e5fb91eded98d12bc074443be4586ce4429369f.jpeg",
    "https://cdn.faire.com/fastly/4904a70f94814b36d5ba97e5121df19ffdc360b8d1985d2d68f537f8566bba60.jpeg",
    "https://cdn.faire.com/fastly/213d6a8c220ea3a95e21e131bae6cb8a82b2eff6478c6e47d80cc18c35e507b5.jpeg",
    "https://cdn.faire.com/fastly/bac8dd8f4859e33d83cad51ceedf5c60976b8d09c2705f3684278b8933fd7b70.jpeg",
    "https://cdn.faire.com/fastly/4e664b7363a6bcdd58eb43a565d80fb5d25e0f0818aa391217132949c496bb5e.jpeg",
    "https://cdn.faire.com/fastly/f9ec9718a271b9b2a58e96824658f9364fbcbe711e196576d74c1495ce9332fa.jpeg",
    "https://cdn.faire.com/fastly/fc2d4917fe5cad80df35fdcb5a881a26333a3a16216254a0b809444933c55097.jpeg",
    "https://cdn.faire.com/fastly/1af28f34a8221565c6379e86a1c0f6b8e30093f2bf9dede23653476092aa2a74.jpeg",
    "https://cdn.faire.com/fastly/33c4ce620667cae39d4758b4078f16b19dd11cda23c8742598b56eb5b99c4015.jpeg",
    "https://cdn.faire.com/fastly/0a6a596659c2547a4ab8d9d9e4cb09470c0138372435379b1c44d395a7593819.jpeg",
    "https://cdn.faire.com/fastly/5d72aed23ea43169f8644af1bd878fc553a1d36d4013c8d670db50b0e491bd77.jpeg",
    "https://cdn.faire.com/fastly/3a7803fbb05b4f494a0f2b0fed70bf81e88a8ca22fcf1a161e040ac57f3e2b7a.jpeg",
    "https://cdn.faire.com/fastly/c8718451de08383e3dffb654adc6a94df49a1326db0fabe65df9c898f65490e9.jpeg",
    "https://cdn.faire.com/fastly/c4d4eaad2e5e6780db0c2b0263d364d2a583f7a0f7444b61e66e685d011c011c.jpeg",
    "https://cdn.faire.com/fastly/c370b2920f409346b4b134945f12389e8127cad8f435ea2473291b916bce1425.jpeg",
    "https://cdn.faire.com/fastly/359ddfcd536cf7e6f10ef4f38b53a7d55f38ab03d782eb20373611fa635ff902.jpeg",
    "https://cdn.faire.com/fastly/2f2a0efdae38fc0c1ca579c112fb0f7f12d70868cc9f1ba9a6087138faf3c420.jpeg",
  ],
  priceDollars: 22,
  description:
    "Blake Half Zip Cropped Sweatshirt and Shorts Set\n\nSporty meets chic in this effortless one piece romper featuring a soft knit texture and a half zip collar for a laid back yet elevated look The relaxed fit and drawstring waist make it perfect for casual days or travel ready styling\n\nHighlights\n- Soft knit fabric with comfy stretch\n- Half zip neckline with wide collar\n- Sleeveless relaxed silhouette\n- Adjustable drawstring waist\n- Easy pull on design with clean hem finish\n\nPerfect For\n- Weekend coffee runs and errand days\n- Effortless airport or road trip outfits\n- Brunch dates and sunny casual plans\n- Layering with denim jackets or cardigans\n\nSPEC:\nLENGTH\t20 5/8\nCHEST\t20 1/2\nSLEEVE\t\nWAIST\t13 1/4\nLENGTH \t9\nLEG OPENING\t11 1/2\n\n\nFabric: 50%Rayon,45%Polyester,5%Spandex\n\n\nModel's height is 5' 8\" and wearing a size S",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:24.938Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
